/**
 * @enum
 */
export const ErrorCodes = {
  Success: 0,
  UnknownError: 1,
  Unauthorized: 2,
  PermissionDenied: 3,
  BadRequest: 4,
  InvalidOTP: 5,
  ExpiredOTP: 6,
  TooManyRequest: 7,
  InvalidOTPEmail: 8,
  BadFieldRequest: 9,
  MultipleBadFieldRequest: 10,
};

/**
 * @enum
 */
export const FieldErrorCodes = {
  FieldRequired: 1,
  InvalidType: 2,
  MinLength: 3,
  MaxLength: 4,
  MinItems: 5,
  MaxItems: 6,
  InvalidPattern: 7,
  // specific codes
  CompanyNameAlreadyExists: -1,
  ImageIsTooBig: -2,
  HqLocationIsNotInCompanyLocations: -3,
  InvalidEmail: -4,
  NameAlreadyExists: -5,
  EditingPublishedArticle: -6,
};

/**
 * @enum
 */
export const DomainLanguageMap = {
  sg: 'en',
  io: 'en',
  vn: 'vi',
  th: 'th',
  id: 'id',
  tw: 'zh_Hant',
};
